up.Layer.prototype.isOpen = function () {
    up.migrate.deprecated('up.Layer#isOpen()', 'up.Layer#isAlive()');
    return this.isAlive();
};
up.Layer.prototype.isClosed = function () {
    up.migrate.deprecated('up.Layer#isClosed()', '!up.Layer#isAlive()');
    return !this.isAlive();
};
